import reducer from './authorization.reducer';

export default reducer;
